import React from "react";
import { colors } from "../../../../utils/theme";
import styled from "styled-components";
import Calendar from "../../../FormComponents/ConfirmAppointComponent/Calendar";
import { TablaTime } from "../../../FormComponents/ConfirmAppointComponent/TablaTime";
import PopupContiniudad from "./Popup";

const ContainerSchedule = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Calendario = styled.div`
  width: 50%;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    width: 80%;
  }
  @media (max-width: 550px) {
    width: 95%;
  }
`;

const Table = styled.div`
  width: 50%;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: center;
    width: 70%;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
  tr {
    font-size: 1.5rem;
    border: 1px solid ${colors.gris};
    text-align: center;
    color: ${colors.fifth};
    font-weight: bold;
  }

  th {
    padding: 1rem;
    color: ${colors.blanco};
  }

  td {
    padding: 1rem;
  }

  thead {
    background-color: ${colors.azul};
  }

  tbody {
    background-color: ${colors.blanco};
  }
`;

const AppoimentAvailability = ({ order, numeroDocumento }) => {
  // const handleConfirmarCita = () => {
  //   alert("confirmar cita")
  // };

  
  return (
    <div>
      <ContainerSchedule>
        {/* calendario */}
        <Calendario>
          <Calendar />
        </Calendario>
        {/* tabla de los horarios */}
        <Table>
          <TablaTime newPatient={false}/>
        </Table>
      </ContainerSchedule>
      <PopupContiniudad orderId={order} numDocu={numeroDocumento}/>
    </div>
  );
};

export default AppoimentAvailability;
